export default class ApiService {
  location = window.location.hostname;
  _apiBase =
      process.env.REACT_APP_NODE_ENV === 'production'
          ? process.env.REACT_APP_QUIZ_API_HOST + '/quizzes/api/public'
          : 'http://172.21.0.4/public';

  getResource = async url => {
    let res = await fetch(
      `${url ? this._apiBase + '/quizzes/' + url : this._apiBase + '/quizzes'}`
    );

    if (!res.ok)
      throw new Error(`Could not fetch ${url} received ${res.status}`);

    return await res.json();
  };


  getQuiz = async url => {
    const quiz = await this.getResource(url);
    return this._transformQuiz(quiz);
  };

  getQuizList = async () => {
    const list = await this.getResource();
    return this._transformList(list);
  };

  getChoosenAnswers = async params => {
    const res = await fetch(
      `${this._apiBase}/choosen-answers${this._buildQuery(params)}`
    );

    if (!res.ok)
      throw new Error(`Could not fetch choosen answers received ${res.status}`);

    return await res.json();
  };

  getChoosenAnswersCsvUrl = params => {
    return `${this._apiBase}/choosen-answers.csv${this._buildQuery(params)}`;
  };

  _buildQuery = params => {
    const query = Object.keys(params || {})
      .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');

    return query ? `?${query}` : '';
  };

  _transformList = data => {
    return {
      list: data
    };
  };

  _transformQuiz = data => {
    return {
      id: data.id,
      questions: data.questions,
      question: data.questions[0],
      name: data.name,
      description: data.description,
      isPartner: data.isPartner,
      isLinkBack: data.isLinkBack,
      quizResults: data.quizResults,
      courseLink: data.courseLink,
      url: data.slug,
      countStarted: data.countStarted,
      countFinished: data.countFinished,
      testType: data.testType,
      backgroundImage: data.backgroundImageUrl,
      logoPartnerImage: data.logoPartnerImageUrl,
      isSnow: data.isSnow
    };
  };
}
